import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loginUser, logoutUser } from '../../../store/actions';
import { useHistory } from 'react-router-dom';
import Cookies from 'js-cookie';

/**
 * AuthInjection is a PageContainer that is responsible for injecting the authentication components.
 *
 * @return
 *  login: () => Void
 *  logout: () => void
 *  error: string
 *  loading: boolean
 *  user: object
 *  isUserLogout: boolean
 */
export const AuthInjection = () => {
  /* constants */
  const dispatch = useDispatch();
  const history = useHistory();

  /**
   * @connectors
   *
   * these methods are responsible for accessing the store and dispatch the actions.
   * these guarantee that the module will be connected independent of methods used.
   * but you should always follow the rules of the methods.
   */

  /**
   * @param username: string
   * @param password: string
   * @param rememberMe: boolean
   *
   * @return Void
   */
  const login = async (username, password, rememberMe) => {
    if (rememberMe) {
      Cookies.set('rememberMe', username);
    } else {
      Cookies.remove('rememberMe');
    }
    dispatch(loginUser({ username, password, rememberMe }, history));
  };

  /**
   * @return Void
   */
  const logout = () => {
    dispatch(logoutUser());
  };

  /**
   * @variables
   *
   * error: string
   * loading: boolean
   * user: object
   */
  const { error, loading, isUserLogout } = useSelector((state) => ({
    error: state.Login.error,
    loading: state.Login.loading,
    isUserLogout: state.Login.isUserLogout,
  }));

  return {
    login,
    logout,
    user: {},
    error,
    loading,
    isUserLogout,
  };
};
